import { Component, OnInit, TemplateRef } from '@angular/core';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { NotaCredito } from '../../../models/nota-credito';
import { NotaCreditoDetalle } from '../../../models/nota-credito-detalle';
import { ComprobanteService } from '../../../services/comprobante.service';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { VentaListModalComponent } from '../../../components/modals/venta-list-modal/venta-list-modal.component';
import { Venta } from '../../../models/venta';
import * as moment from 'moment';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { Validation } from '../../../config/validation';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { UtilsService } from '../../../services/utils.service';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { VentaNotaModalComponent } from '../../modals/venta-nota-modal/venta-nota-modal.component';
import { VentaService } from '../../../services/venta.service';
import { ValidarCorreoService } from '../../../services/validar-correo.service';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { PeriodoContable } from '../../../models/periodo-contable';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
@Component({
	selector: 'app-nota-credito-add',
	templateUrl: './nota-credito-add.component.html',
	styleUrls: ['./nota-credito-add.component.css'],
	providers: [
		ComprobanteService, 
		CajaService, 
		ParametroService, 
		NotaCreditoService,
		VentaService, 
		ValidarCorreoService,
		ImpuestoPorcentajeService,
		ParametroContabilidadService,
        PeriodoContableService,
	]
})
export class NotaCreditoAddComponent implements OnInit {
	public nota_credito: NotaCredito;
	public notaCreditoDetalle: Array<NotaCreditoDetalle>;
	public nota_detalle: NotaCreditoDetalle;
	public caja: Caja;
	public cajas: Array<Caja>;
	public msgSweet: SweetMessage;
	public loading = false;
	public Mod_FactElec: string;
	public fecha_emision;
	public bsModalRef: BsModalRef;
	public venta: Venta;
	public IVA: number;
	public IVA_PARAM: number;
	public vl: Validation;
	public detalle: String;
	public total_pago: number;
	public cambio: number;
	public is_numero_manual: boolean;
	public numero_documento: String;
	public fecha_actual;
	public fecha_MesAnt;
	public correos: Array<any>;
	public cantidad_excedidad:boolean;
	public correo_invalid:Boolean;
	public parametros: Array<any>
    public iva_id : number;
	public iva_vigente:boolean;
	public iva_porcentaje : any;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;
    public parametrosContabilidad: Array<ParametroContabilidad>;
    public periodoContable: PeriodoContable;
	constructor(
		public comprobanteService: ComprobanteService,
		private ss: SessionService,
		public cajaService: CajaService,
		private modalService: BsModalService,
		private parametroService: ParametroService,
		private notaCreditoService: NotaCreditoService,
		public utils: UtilsService,
		public ventaService: VentaService,
		public correoService: ValidarCorreoService,
		public impuestoPorcentajeService: ImpuestoPorcentajeService,
		private parametroContabilidadService: ParametroContabilidadService,
		private periodoContableService: PeriodoContableService,

	) {
		this.caja = new Caja();
		this.cajas = [];
		this.correos = [];
		this.msgSweet = new SweetMessage();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.nota_credito = new NotaCredito();
		this.notaCreditoDetalle = [];
		this.fecha_emision = moment(this.fecha_emision);
		this.fecha_actual = moment(this.fecha_actual);
		this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.venta = new Venta();
		this.IVA = 0;
		this.IVA_PARAM = 0;
		this.vl = new Validation();
		this.detalle = "";
		this.nota_detalle = new NotaCreditoDetalle();
		this.total_pago = 0;
		this.cambio = 0;
		this.is_numero_manual = false;
		this.numero_documento = "";
		this.cantidad_excedidad = false;
		this.parametros = [];
        this.iva_id = 0;
		this.iva_vigente = false;
		this.iva_porcentaje = 0;
		this.Mod_Cartera = this.ss.getData("mod_cartera");
        this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
        this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
		this.venta.fecha_emision = moment();
	}

	ngOnInit() {
		let p1 = this.getCajas();
		let p2 = this.getParametros();
		let p3 = this.getParamDocumentoManual();
		let p4 = this.getIVA(129);
		let p5 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p5 = this.getParametroContabilidadNotaCredito();
		}
		this.loading = true;

		Promise.all([p1, p2, p3,p4,p5]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}
	getParametroContabilidadNotaCredito(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?in[tipo]=V,P,G&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msgSweet.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
	}
	getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment(this.nota_credito.fecha_emision).format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
    }
	
	setValueAsientoContable(){
        
        let asientoContable = new AsientoContable();
        let asientoContableCobros = new AsientoContable();
        asientoContable.fecha_emision = this.nota_credito.fecha_emision;
        asientoContable.tipocomprobante = this.nota_credito.tipocomprobante;
        asientoContable.tipo_comprobante_id = this.nota_credito.tipo_comprobante_id;
        asientoContable.periodo_contable_id = this.periodoContable.id;
        asientoContable.numero_documento = this.nota_credito.numero_documento;
		asientoContable.descripcion = this.venta.cliente.nombre_comercial;
		asientoContable.status = 'A';
        asientoContable.empresa_id = this.nota_credito.empresa_id;
        asientoContable.usuario_id = this.nota_credito.usuario_id;
        asientoContable.total = this.nota_credito.total;
        asientoContableCobros.fecha_emision = this.nota_credito.fecha_emision;
        asientoContableCobros.tipocomprobante = this.nota_credito.tipocomprobante;
        asientoContableCobros.tipo_comprobante_id = this.nota_credito.tipo_comprobante_id;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = this.nota_credito.numero_documento;
        asientoContableCobros.descripcion = this.venta.cliente.nombre_comercial;
        asientoContableCobros.empresa_id = this.nota_credito.empresa_id;
        asientoContableCobros.usuario_id = this.nota_credito.usuario_id;
        asientoContableCobros.total = this.nota_credito.total;
        asientoContableCobros.status = (this.nota_credito.tipo == 'CR') ? 'E':'A';
       

        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContable.empresa_id;
			asientoContableDetalle.usuario_id = asientoContable.usuario_id;
			
			if(parametroContabilidad.id == '31'){
				parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.nota_credito.total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.nota_credito.total:0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable; 
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);  
				}     
			}
				
			if( parametroContabilidad.id == "10") {
				parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.nota_credito.total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.nota_credito.total:0;
				// asientoContableCobros.detalle.push(asientoContableDetalle);
				if(parametroContabilidad.tipo_saldo == 'H'){
					// asientoContable.detalle.push(asientoContableDetalle);
					asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					// asientoContable.detalle.unshift(asientoContableDetalle);
					asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
		});
		let subtotal = 0;
        let subtotalCobro = 0;
        this.nota_credito.detalle.forEach(compraDetalle => {
			
			
				let asientoContableDetalle = new AsientoContableDetalle();
				asientoContableDetalle.empresa_id = asientoContable.empresa_id;
				asientoContableDetalle.usuario_id = asientoContable.usuario_id;
				asientoContableDetalle.cuenta_contable_id = compraDetalle.cuenta_inventario_id;
				let parametroContabilidad = this.parametrosContabilidad.filter(parametro => parametro.id == '30')[0];
				parametroContabilidad.tipo_saldo ="D";
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(compraDetalle.total,2):0;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(compraDetalle.total,2):0;
				let cuenta = asientoContable.detalle.filter( asientoDetalle=> compraDetalle.cuenta_inventario_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_inventario_id );
				
				if( cuenta.length > 0 ) {
					let indexAsientoDetalle = asientoContable.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuenta[0].cuenta_contable_id);
					asientoContable.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_inventario_id
					asientoContable.detalle[indexAsientoDetalle].haber +=  parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(compraDetalle.total,2):0;
					asientoContable.detalle[indexAsientoDetalle].debe +=  parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(compraDetalle.total,2):0;
					
				}else if( cuenta.length == 0 && compraDetalle.cuenta_inventario_id !="0" ) {
					// asientoContable.detalle.push(asientoContableDetalle);
					if(parametroContabilidad.tipo_saldo == 'H'){
						asientoContable.detalle.push(asientoContableDetalle);
						// asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						asientoContable.detalle.unshift(asientoContableDetalle);
						// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			
				subtotalCobro = this.utils.redondear(Number(compraDetalle.total),2);
			let asientoContableDetalleCobro = new AsientoContableDetalle();
			asientoContableDetalleCobro.empresa_id = asientoContableCobros.empresa_id;
            asientoContableDetalleCobro.usuario_id = asientoContableCobros.usuario_id;
			asientoContableDetalleCobro.cuenta_contable_id = compraDetalle.cuenta_costo_gasto_id;
			
			let parametroContabilidadCobro = this.parametrosContabilidad.filter(parametro => parametro.id == '28')[0];
			parametroContabilidadCobro.tipo_saldo = "D";
			asientoContableDetalleCobro.debe = parametroContabilidadCobro.tipo_saldo=='D'?subtotalCobro:0;
			asientoContableDetalleCobro.haber = parametroContabilidadCobro.tipo_saldo=='H'?subtotalCobro:0;
			
			let cuentaCobro = asientoContableCobros.detalle.filter( asientoDetalle=> compraDetalle.cuenta_costo_gasto_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_costo_gasto_id );
			
			if( cuentaCobro.length > 0 ) {
				let indexAsientoDetalle = asientoContableCobros.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuentaCobro[0].cuenta_contable_id);
				asientoContableCobros.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_costo_gasto_id
				asientoContableCobros.detalle[indexAsientoDetalle].haber +=  (parametroContabilidadCobro.tipo_saldo=='H'?subtotalCobro:0);
				asientoContableCobros.detalle[indexAsientoDetalle].debe +=  (parametroContabilidadCobro.tipo_saldo=='D'?subtotalCobro:0);
				
			}else if( cuentaCobro.length == 0 && compraDetalle.cuenta_costo_gasto_id !="0" ) {
				// asientoContableCobros.detalle.unshift(asientoContableDetalleCobro);
				if(parametroContabilidad.tipo_saldo == 'H'){
					// asientoContable.detalle.push(asientoContableDetalle);
					asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					// asientoContable.detalle.unshift(asientoContableDetalle);
					asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
		});
		this.nota_credito.asientosContables.push(asientoContable);
		this.nota_credito.asientosContables.push(asientoContableCobros);
    }

	getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.IVA_PARAM = this.iva_porcentaje;
					this.calcularTotal();
					resolve(true);
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					this.IVA_PARAM = 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getCajas() {
		return new Promise((resolve, reject) => {
			this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
				res => {
					this.cajas = res.data;
					resolve();
				},
				err => {
					this.cajas = [];
					reject(err);
				}
			);
		});
	}

	onChangeCaja() {
		

		this.getNumeroComprobante();
	}

	getParamDocumentoManual() {
		// VALORES RESPONSE: SI, NO
		return new Promise((resolve, reject) => {
			let documento_manual_id = 9;
			this.parametroService.getById(documento_manual_id).subscribe(
				res => {
					this.is_numero_manual = (res.valor.toString().trim() === "SI");
					resolve();
				},
				err => {
					this.is_numero_manual = false;
					reject(err);
				}
			);
		});
	}

	getNumeroComprobante() {		
		if (!this.caja.id) {
			this.msgSweet.showMessage('error-message', "Seleccione la caja");
			this.nota_credito.numero_documento = "";
			return;
		}

		let caja = this.cajas.filter(x => x.id = this.caja.id)[0];

		// if (!this.caja) {
		// 	this.caja = new Caja();
		// }

		this.loading = true;

		if (this.Mod_FactElec) {
			this.nota_credito.tipo_comprobante_id ="9";
		}
		else {
			this.nota_credito.tipo_comprobante_id = "8";
		}
		this.comprobanteService.getSecuencial(this.nota_credito.tipo_comprobante_id, caja.id).subscribe(
			res => {
				this.loading = false;
				if (res.secuencial) {
					this.nota_credito.serie = caja.sucursal.establecimiento;
					this.nota_credito.punto_emision = caja.punto_emision;
					this.nota_credito.secuencial = res.secuencial;

					this.nota_credito.numero_documento = this.nota_credito.serie + "-" + this.nota_credito.punto_emision + "-" + this.nota_credito.secuencial;

				} else {
					this.nota_credito.serie = "";
					this.nota_credito.punto_emision = "";
					this.nota_credito.secuencial = "";
					this.nota_credito.numero_documento = "";
				}
			},
			err => {
				this.loading = false;
				this.nota_credito.serie = "";
				this.nota_credito.punto_emision = "";
				this.nota_credito.secuencial = "";
				this.nota_credito.numero_documento = "";

				this.msgSweet.showMessage('error-message', err);
			}
		);
	}

	onSearch() {
		let qs = "";//"&embed=retencion";
		const initialState = { qs };
		this.bsModalRef = this.modalService.show(VentaNotaModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.onSelectedRow.take(1).subscribe(venta => {
			this.getDataVenta(venta);
		});
	}

	getDataVenta(venta){
		this.ventaService.getById(venta.id, "?embed=tipocomprobante,bodega,guiaremision,retencion,cliente?embed=tipoidentificacion,detalle?embed=producto").subscribe(res=>{
			this.venta = res.data;
			this.correos = this.venta.cliente.correo.split(',');
			this.notaCreditoDetalle = [];

			this.venta.detalle.forEach(item => {
				let detalle = new NotaCreditoDetalle();
				detalle.cantidad = item.cantidad;
				detalle.cantidad_original = item.cantidad;
				detalle.precio_unitario = parseFloat(item.precio_unitario.toString());
				detalle.producto = item.producto;
				detalle.detalle = item.detalle;
				//detalle.producto.unidadmedida.nombre = item.unidad;
				//detalle.producto. TODO: falta cantidad stock
				detalle.desc_porcent = parseFloat(item.desc_porcent.toString());
				detalle.desc_valor = parseFloat(item.desc_valor.toString());
				detalle.subtotal = parseFloat(item.subtotal.toString());
				//item.precio_unitario
				detalle.usuario_id = this.ss.getData('usuario_id');
				detalle.empresa_id = this.ss.getData('empresa_id');
				detalle.sucursal_id = this.ss.getData('sucursal_id');

				this.notaCreditoDetalle.push(detalle);
			});

			this.calcularTotal();
			
		},err=>{

		});
	}

	getSubtotal(venta) {
		return parseFloat(venta.subtotal_iva12) + parseFloat(venta.subtotal_iva0);
	}

	sendObjectProducto(producto: any) {
		let temp = this.notaCreditoDetalle.find(x => x.producto_id == producto.id);

		if (!temp) {
			let notaCreditoDetalle = new NotaCreditoDetalle();
			notaCreditoDetalle.producto = producto;
			notaCreditoDetalle.precio_unitario = parseFloat(producto.precio);
			notaCreditoDetalle.subtotal = notaCreditoDetalle.cantidad * notaCreditoDetalle.precio_unitario;

			if (parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4) {
				if (producto.graba_iva === 0) {
					notaCreditoDetalle.iva = 0;
					notaCreditoDetalle.porct_iva = 0;
				} else {
					notaCreditoDetalle.iva = notaCreditoDetalle.subtotal * this.IVA;
					notaCreditoDetalle.porct_iva = this.IVA_PARAM;
				}
			} else {
				notaCreditoDetalle.iva = 0;
				notaCreditoDetalle.porct_iva = 0;
			}

			notaCreditoDetalle.total = notaCreditoDetalle.subtotal + notaCreditoDetalle.iva;
			notaCreditoDetalle.usuario_id = this.ss.getData('usuario_id');
			notaCreditoDetalle.empresa_id = this.ss.getData('empresa_id');
			notaCreditoDetalle.sucursal_id = this.ss.getData('sucursal_id');

			this.notaCreditoDetalle.push(notaCreditoDetalle);
			this.calcularTotal();
		}

	}

	verificationValue(event, notaCreditoDetalle: NotaCreditoDetalle, campo: string) {
		notaCreditoDetalle[campo]= event.target.value;
		this.cantidad_excedidad = false;
		this.notaCreditoDetalle.forEach(nc=>{
			if(nc.cantidad > nc.cantidad_original){
			
				this.msgSweet.showMessage('error-message', "La cantidad no puede ser mayor a la de la factura de compra");
				this.cantidad_excedidad= true;
			}
		});

		if (event.target.value.trim().length === 0) {
			if (campo === 'cantidad'  ) {
				notaCreditoDetalle[campo] = 1;
				
			} else {
				notaCreditoDetalle[campo] = 0;
			}

			
		}
	}

	changeValue(event, notaCreditoDetalle: NotaCreditoDetalle, campo: string) {
		notaCreditoDetalle[campo] = event.target.value;
		notaCreditoDetalle.subtotal = notaCreditoDetalle.cantidad * notaCreditoDetalle.precio_unitario;


		let valor = this.utils.redondear((notaCreditoDetalle.cantidad * notaCreditoDetalle.precio_unitario), 2);
		let subtotal = valor - notaCreditoDetalle.desc_valor;
		//let porcent_value = subtotal * (notaCreditoDetalle.desc_porcent / 100)
		notaCreditoDetalle.subtotal = subtotal;


		this.calcularTotal();
	}

	onDelete(i) {
		this.notaCreditoDetalle.splice(i, 1);
		this.calcularTotal();
	}

	openModalDetalle(template: TemplateRef<any>, nota_detalle) {
		this.detalle = nota_detalle.detalle;
		this.nota_detalle = nota_detalle;
		this.bsModalRef = this.modalService.show(template);
	}

	saveDetalle() {
		this.nota_detalle.detalle = this.detalle.toString().trim();
		this.detalle = "";
		this.bsModalRef.hide();
	}

	calcularTotal() {
		this.nota_credito.subtotal_iva12 = 0;
		this.nota_credito.subtotal_iva0 = 0;
		this.nota_credito.iva = 0;
		this.nota_credito.total = 0;
		let tipo_comprobante_id = parseInt(this.venta.tipo_comprobante_id.toString());

		this.notaCreditoDetalle.forEach(obj => {
			if ((tipo_comprobante_id === 1 && obj.producto.graba_iva) || tipo_comprobante_id === 4 && obj.producto.graba_iva) {
				this.nota_credito.subtotal_iva12 += parseFloat(obj.subtotal.toString());
			} else {
				this.nota_credito.subtotal_iva0 += parseFloat(obj.subtotal.toString());
			}
		});

		if (tipo_comprobante_id === 1 || tipo_comprobante_id === 4) {
			this.nota_credito.iva = Math.round((this.nota_credito.subtotal_iva12 * this.IVA) * 100) / 100;
		} else {
			this.nota_credito.iva = Math.round(this.nota_credito.subtotal_iva12 * 100) / 100;
		}

		this.nota_credito.subtotal = parseFloat(this.nota_credito.subtotal_iva0.toString()) + parseFloat(this.nota_credito.subtotal_iva12.toString());
		this.nota_credito.total = parseFloat(this.nota_credito.subtotal.toString()) + parseFloat(this.nota_credito.iva.toString());

		//Recalcular cambio
		this.total_pago = 0;
		this.cambio = (this.total_pago > this.nota_credito.total ? (this.total_pago - this.venta.total) : 0);
		this.cambio = Math.round(this.cambio * 100) / 100;
	}

	setNCElectronica() {
		let NcElectronica = {};
		NcElectronica['datos'] = {};
		NcElectronica['datos']['infoTributaria'] = {};
		NcElectronica['datos']['infoTributaria']['ambiente'] = "";
		NcElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
		NcElectronica['datos']['infoTributaria']['razonSocial'] = "";
		NcElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
		NcElectronica['datos']['infoTributaria']['claveAcceso'] = "";
		NcElectronica['datos']['infoTributaria']['codDoc'] = "04"; //Nota de Crédito
		NcElectronica['datos']['infoTributaria']['estab'] = this.nota_credito.serie;
		NcElectronica['datos']['infoTributaria']['ptoEmi'] = this.nota_credito.punto_emision;
		NcElectronica['datos']['infoTributaria']['secuencial'] = this.nota_credito.secuencial.toString().padStart(9, "0");
		NcElectronica['datos']['infoTributaria']['dirMatriz'] = "";

		NcElectronica['datos']['infoNotaCredito'] = {};
		NcElectronica['datos']['infoNotaCredito']['fechaEmision'] = moment(this.nota_credito.fecha_emision).format("DD/MM/YYYY");
		NcElectronica['datos']['infoNotaCredito']['dirEstablecimiento'] = "";
		NcElectronica['datos']['infoNotaCredito']['tipoIdentificacionComprador'] = this.venta.cliente.tipoidentificacion.cod_dni;
		NcElectronica['datos']['infoNotaCredito']['razonSocialComprador'] = this.venta.cliente.razon_social;
		NcElectronica['datos']['infoNotaCredito']['identificacionComprador'] = this.venta.cliente.dni;
		if (this.venta.cliente.es_contribuyente) {
			NcElectronica['datos']['infoNotaCredito']['contribuyenteEspecial'] = this.venta.cliente.num_contribuyente;
		}
		NcElectronica['datos']['infoNotaCredito']['obligadoContabilidad'] = (this.venta.cliente.es_obligado == true ? "SI" : "NO");
		NcElectronica['datos']['infoNotaCredito']['codDocModificado'] = "01"; //FACTURA
		NcElectronica['datos']['infoNotaCredito']['numDocModificado'] = this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial.toString().padStart(9, "0");
		NcElectronica['datos']['infoNotaCredito']['fechaEmisionDocSustento'] = moment(this.venta.fecha_emision).format("DD/MM/YYYY");
		NcElectronica['datos']['infoNotaCredito']['totalSinImpuestos'] = (this.nota_credito.subtotal_iva12 + this.nota_credito.subtotal_iva0);
		NcElectronica['datos']['infoNotaCredito']['valorModificacion'] = this.nota_credito.total;
		NcElectronica['datos']['infoNotaCredito']['moneda'] = "DOLAR";

		NcElectronica['datos']['infoNotaCredito']['totalConImpuestos'] = [];
		if (this.nota_credito.subtotal_iva0 > 0) {
			let totalConImpuestos = {};
			totalConImpuestos['codigo'] = 2;
			totalConImpuestos['codigoPorcentaje'] = 0;
			totalConImpuestos['baseImponible'] = this.nota_credito.subtotal_iva0;
			totalConImpuestos['valor'] = "0.00";

			NcElectronica['datos']['infoNotaCredito']['totalConImpuestos'].push(totalConImpuestos);
		}

		if (this.nota_credito.subtotal_iva12 > 0) {
			let totalConImpuestos = {};
			totalConImpuestos['codigo'] = 2;
			totalConImpuestos['codigoPorcentaje'] = 2;
			totalConImpuestos['baseImponible'] = this.nota_credito.subtotal_iva12;
			totalConImpuestos['valor'] = this.nota_credito.iva;

			NcElectronica['datos']['infoNotaCredito']['totalConImpuestos'].push(totalConImpuestos);
		}

		NcElectronica['datos']['infoNotaCredito']['motivo'] = this.nota_credito.motivo;

		NcElectronica['datos']['detalles'] = [];
		this.nota_credito.detalle.forEach((item) => {
			let detalle = {};
			let detalle_item = item.detalle.toString().replace(/\n/g, ", ");

			detalle['codigoInterno'] = (item.producto.codigo).replace(/\//g, '-');
			detalle['codigoAdicional'] = (item.producto.codigo).replace(/\//g, '-');
			detalle['descripcion'] = (item.producto.nombre + (item.detalle.length > 0 ? " - " + detalle_item : "")).replace(/\//g, '-');
			detalle['cantidad'] = item.cantidad;
			detalle['precioUnitario'] = item.precio_unitario;
			detalle['descuento'] = 0;
			detalle['precioTotalSinImpuesto'] = item.subtotal;
			/*detalle['detallesAdicionales'] = [];
			let detAdicional = {};*/

			detalle['impuestos'] = [];
			let impuesto = {};
			impuesto['codigo'] = 2;
			impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0);
			impuesto['tarifa'] = (item.iva > 0 ? 12 : 0);
			impuesto['baseImponible'] = item.subtotal;
			impuesto['valor'] = Math.round(item.iva * 100) / 100;
			detalle['impuestos'].push(impuesto);
			NcElectronica['datos']['detalles'].push(detalle);
		});

		NcElectronica['datos']['infoAdicional'] = [];
		let adicional = {};
		adicional['Email'] = this.correos.toString();// this.venta.cliente.correo;
		adicional['Direccion'] = this.venta.cliente.direccion.replace(/\//g, '-');

		let telefono = "0999999999";
		if (this.venta.cliente.telefono.toString().trim().length > 0) {
			telefono = this.venta.cliente.telefono.toString();
		}
		if (this.venta.cliente.celular.toString().trim().length > 0) {
			telefono = this.venta.cliente.celular.toString();
		}
		adicional['Telefono'] = telefono;

		NcElectronica['datos']['infoAdicional'].push(adicional);

		return NcElectronica;
	}

	onSubmit() {

		let preg = "¿Está seguro de querer guardar el documento?";
		const initialState = { Pregunta: preg, Respuesta: false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, { initialState }));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if (Respuesta == true) {
				let qs = "";
				this.setValueEntity();

		

				if (this.Mod_FactElec) {
					if (this.venta.cliente.es_contribuyente) {
						if (this.venta.cliente.num_contribuyente.toString().trim().length === 0) {
							this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
							return false;
						}
					}
					this.nota_credito.json_string = this.setNCElectronica();
				}

				if( this.Mod_Cartera && this.Mod_Contabilidad ){

					this.getPeriodoActual().then(
						res => {
							this.setValueAsientoContable();
							   this.saveNotaCredito();     
						}
					);
				}else {
				   this.saveNotaCredito();   
				}

				
			}
		});
	}

	saveNotaCredito(){
		this.loading = true;
		this.notaCreditoService.save(this.nota_credito).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');

				this.nota_credito = new NotaCredito();
				this.notaCreditoDetalle = [];
				this.nota_detalle = new NotaCreditoDetalle();
				this.venta = new Venta();
				this.correos = [];
				this.numero_documento = "";
				this.cambio = 0;
				this.total_pago = 0;
				this.caja = new Caja();
			},
			err => {
				this.loading = false;
				this.msgSweet.showMessage('error-message', err);
			}
		);
	}

	setValueEntity() {
		this.nota_credito.is_secuencial_manual = this.is_numero_manual;
		if (this.is_numero_manual) this.nota_credito.numero_documento = this.numero_documento;
		this.nota_credito.tipo = "V";
		this.nota_credito.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")
		this.nota_credito.caja_id = this.caja.id;
		this.nota_credito.documento_id = this.venta.id;
		this.nota_credito.correo = this.venta.cliente.correo;

		this.notaCreditoDetalle.forEach(detalle => {
			detalle.cuenta_ingreso_id = detalle.producto.cuenta_ingreso_id;
			detalle.cuenta_inventario_id = detalle.producto.cuenta_inventario_id;
			detalle.cuenta_costo_gasto_id = detalle.producto.cuenta_costo_gasto_id;
			detalle.producto_id = detalle.producto.id;
			if (parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4) {
				if (!detalle.producto.graba_iva) {
					detalle.iva = 0;
				} else {
					detalle.iva = detalle.subtotal * this.IVA;
				}
			} else {
				detalle.iva = 0;
			}
			detalle.total = detalle.subtotal + detalle.iva;
		});

		this.nota_credito.detalle = this.notaCreditoDetalle;

		this.nota_credito.usuario_id = this.ss.getData('usuario_id');
		this.nota_credito.empresa_id = this.ss.getData('empresa_id');
		this.nota_credito.sucursal_id = this.ss.getData('sucursal_id');
	}

	isValidForm() {
		if (this.nota_credito.motivo.trim().length < 1) {
			return false;
		}
		if (this.is_numero_manual) {
			if (this.numero_documento.trim().length === 0) {
				return false;
			} else {
				if (parseFloat(this.numero_documento.trim()) < 1) {
					return false;
				}
			}
		}
		if (!this.caja.id) {
			return false;
		}
		if (!this.nota_credito.tipo_comprobante_id) {
			return false;
		}
		if (!this.nota_credito.numero_documento) {

		}
		if (!this.venta.id) {
			return false;
		}
		if (this.notaCreditoDetalle.length < 1) {
			return false;
		}
		if (this.Mod_FactElec) {
			if (this.venta.cliente.correo.trim().length === 0) {
				return false;
			}
		}
		let b = false;
		this.notaCreditoDetalle.forEach(item => {
			if (item.cantidad < 1 || item.precio_unitario == 0 ) {
				b = true;
			}
		});
		if (b) {
			return false;
		}
		if (this.fecha_emision < this.fecha_MesAnt) {
			return false;
		}
		if (!this.correos.length) {
			return false;
		}
		if (this.cantidad_excedidad) {
			return false;
		}
		if (this.correo_invalid) {
			return false;
		}
		return true;
	}

	add(detalle) {
		if (detalle.cantidad < detalle.cantidad_original) {
			detalle.cantidad++;

			detalle.subtotal = detalle.cantidad * detalle.precio_unitario;

			this.calcularTotal();
		}
	}

	sub(detalle) {
		if (detalle.cantidad > 1) {
			detalle.cantidad--;

			detalle.subtotal = detalle.cantidad * detalle.precio_unitario;

			this.calcularTotal();
		}
	}

	onChangeFecha(event) {
		if (event < this.fecha_MesAnt) {
			this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");
		}
	}

	validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/nota-credito-add/nota-credito-add.component.ts